function setLogoWith() {
     // Elements
     /*let header = document.querySelector('.header-wrapper');*/
     let b2bAnnouncement = document.querySelector('.b2b-announcement');
     
     if (window.pageYOffset > 10) {
         header.classList.remove("intro");
            b2bAnnouncement && b2bAnnouncement.classList.remove("hidden");
        } else {
            header.classList.add("intro");
            b2bAnnouncement && b2bAnnouncement.classList.add("hidden");
        }
        
        const btn = document.querySelector(".header__icon--menu");
              btn.addEventListener("click", function () {
                window.scrollTo(window.scrollX, window.scrollY + 20); 
         });
}

window.addEventListener('scroll', function() {
         if (document.body.classList.contains('home')) {
        setLogoWith();
     }
 });


document.addEventListener("DOMContentLoaded", function() {
     if (document.body.classList.contains('home')) {
         setLogoWith();
     }
});

window.addEventListener('resize', function() {
    if (document.body.classList.contains('home')) {
        setLogoWith();
    }
});

function showCart() {
    refreshCart();

    const cartWrapper = document.querySelector('.cart-drawer-form');
    cartWrapper.classList.remove("hidden");
    var top = -1 * window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = top.toString() + 'px';
    document.body.style.right = "0px";
    document.body.style.left = "0px";
}

function hideCart() {
    const cartWrapper = document.querySelector('.cart-drawer-form');
    cartWrapper.classList.add("hidden");

    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.right = "unset";
    document.body.style.left = "unset";

    window.scrollTo(0, parseInt(scrollY || '0') * -1);
}


function refreshCart() {

    const items = document.querySelector(".cart-items");
    const empty = document.querySelector(".cart-empty-box");
    
    var cartContents = fetch('/cart.js').then(response => response.json()).then(data => { 
            
        // Cart Items
        if (data.items.length > 0) {
            empty.classList.add("hide");
            var cartItemsHTML = "";
            
            
            data.items.forEach(item => {
                var length = "";
                var price = item.final_price / 100;
                price = new Intl.NumberFormat('en-GB', { style: 'currency', currency: data.currency }).format(price);
                
                if (item.options_with_values.length >= 2) {
                    length = "Length " + item.options_with_values[1].value;
                }

                var itemHTML = '<li><div class="cart-item"><div class="cart-item-img">'
                itemHTML += '<a href="' + item.url + '"><img src="' + item.featured_image.url + '" /></a></div>';
                itemHTML += '<div class="cart-item-details">';
                itemHTML += '<div class="cart-item-title"><a href="' + item.url + '">' + item.product_title + '</a></div>'
                itemHTML += '<div class="cart-item-price">' + price + '</div>'
                itemHTML += '<div class="cart-item-length">' + length + '</div>'
                itemHTML += '</div>';
                itemHTML += "</div></li>";
                cartItemsHTML += itemHTML;
            });

            items.innerHTML = cartItemsHTML;
        } else {
            empty.classList.remove("hide");
        }
    
    
        return data;
    });
}

function CreateEvent(event, data) {

    switch(event) {
        case "add_to_cart":
            gtag("event", "add_to_cart", data);
            break;
        case "click":
            break;
            break;
    }
}


const buttons = document.querySelectorAll('.ga4')
buttons.forEach(function(currentBtn){

    currentBtn.addEventListener('click', event => {

        CreateEvent(event.target.dataset.event, event.target.dataset.value);  
    });
})